module.exports = __webpack_public_path__ + "assets/img/news (43).8ee15df7.png";